export default __webpack_public_path__ + "static/10-most-instagrammable-places-on-earth-sweden-6c52cec2aa7605ac0a24eb2f1fa7ec43.jpg";